import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDebounce } from '../../hooks/use-debounce.hook';
import { SelectInputComponent } from '../components/select-input.component';
import { getOptions, getValue } from '../services/select-input.service';

export function SelectInputContainer({
  optionName,
  isDisabled,
  valueField,
  name,
  onTypeahead,
  isRequired,
  list,
  label,
  className,
  onValueChange,
  labelField,
  value,
}: any) {
  const [inputValue, setInputValue] = useState({
    event: null,
    value: getValue({ list, value, valueField, labelField }),
  });

  const [options, setOptions] = useState(
    getOptions({ list, valueField, labelField }),
  );
  const debouncedInputValue = useDebounce(inputValue, 500);

  useEffect(() => {
    if (
      inputValue?.event &&
      !_.isEmpty(debouncedInputValue) &&
      !_.isEmpty(inputValue) &&
      debouncedInputValue === inputValue
    ) {
      onValueChange({
        persist: () => {},
        target: {
          type: 'change',
          label,
          value: debouncedInputValue?.value?.value,
        },
      });
    }
  }, [debouncedInputValue]);

  const [searchValue, setSearchValue] = useState({
    event: null,
    value: value?.label || '',
  });

  const debouncedTypeaheadValue = useDebounce(searchValue, 500);

  useEffect(() => {
    if (
      onTypeahead &&
      searchValue?.event &&
      !_.isEmpty(debouncedTypeaheadValue) &&
      !_.isEmpty(searchValue) &&
      debouncedTypeaheadValue === searchValue
    ) {
      onTypeahead(debouncedTypeaheadValue?.value);
    }
  }, [debouncedTypeaheadValue]);

  useEffect(() => {
    setInputValue({
      event: null,
      value: getValue({ list, value, valueField, labelField }),
    });
  }, [value]);
  useEffect(() => {
    setOptions(getOptions({ list, valueField, labelField }));
    setInputValue({
      event: null,
      value: getValue({ list, value, valueField, labelField }),
    });
  }, [list]);
  const typeaheadProps =
    (onTypeahead && {
      onTypeahead: (event: any, newInputValue: any) => {
        setSearchValue({ event, value: newInputValue });
      },
      searchValue: searchValue?.value || '',
    }) ||
    {};

  return (
    <SelectInputComponent
      className={className}
      isDisabled={isDisabled}
      isRequired={isRequired}
      label={label}
      labelField={labelField}
      name={name}
      onValueChange={(event: any) => {
        const selectedOption = options.find((option:any) => {
          return option.value == event.target.value;
        });
        setInputValue({
          event,
          value: { value: selectedOption?.value, label: selectedOption?.label },
        });
      }}
      options={options}
      value={inputValue?.value?.value}
      valueField={valueField}
      optionName={optionName}
      {...typeaheadProps}
    />
  );
}
